export function eloop(fn) {
  return new Promise((resolve, reject) => {
    try {
      let result = fn();
      if (result) {
        setTimeout(fn, 0);
      } else {
        resolve();
      }
    } catch (e) {
      reject();
    }
  });
}

export function createLogger({ delay = 1000, tag = "Batch" } = {}) {
  let id = 0;
  let handle = null;
  let entities = [];

  return (...args) => {
    entities.push(args);
    if (handle != null) {
      clearTimeout(handle);
      handle = null;
    }

    handle = setTimeout(() => {
      console.group(`${tag}-${id}`);
      eloop(
        () => {
          const entity = entities.shift();
          console.log(...entity);
          return entities.length > 0;
        }
      )
        .then(() => {
          handle = null;
          id++;
          console.groupEnd(`Batch-${id}`);
        });
    }, delay);
  }
}


export const blog = createLogger("Batch");
